import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import './styles/theme.css';

const syncBrowserThemeColor = () => {
  const themeColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--color-primary')
    .trim();
  const themeMeta = document.querySelector('meta[name="theme-color"]');
  if (themeMeta && themeColor) {
    themeMeta.setAttribute('content', themeColor);
  }
};

syncBrowserThemeColor();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);